import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { closeAccessModel, openAccessModel, removeAccessModel, searchAccessModel, updateAccessModel } from './accessSagaActions';
import { PayloadAction } from '@reduxjs/toolkit';
import { setIsShowAccessModal, setIsShowLoader, setAccessList, setOpenedAccessModelId, getOpenedAccessModelId, setSearchedUsers } from '../../reducers/accessControl/accessControlReducer';
import { AccessProviderInstance } from '../../@shared/services/AccessProvider';
import RespondClient from '../../@shared/Models/RespondClient';
import { AccessesToModelsDto, CreateAccessesToModels } from '../../@shared/Models/AccessModels';
import { onThrowAlert } from '../dataSaga/dataSagaActions';
import { NotificationModel } from '../../reducers/main/mainModel';
import { User } from '../../@shared/Models/Models';

const accessSaga = [
    takeLatest(openAccessModel, watchOpeningAccessModel),
    takeLatest(searchAccessModel, watchSearchingAccessModel),
    takeLatest(closeAccessModel, watchClosingAccessModel),
    takeLatest(updateAccessModel, watchUpdatingAccessModel),
    takeLatest(removeAccessModel, watchRemovingAccessModel),
]

export default accessSaga;

export function* watchOpeningAccessModel({ payload: data }: PayloadAction<string>): Generator {
    yield put(setIsShowLoader(true));
    yield put(setOpenedAccessModelId(data));
    yield put(setIsShowAccessModal(true));
    const list = (yield call([AccessProviderInstance, AccessProviderInstance.get], data)) as RespondClient<AccessesToModelsDto[]>;
    yield put(setAccessList(list.data));

    yield put(setIsShowLoader(false));

}

export function* watchUpdatingAccessModel({ payload: data }: PayloadAction<CreateAccessesToModels>): Generator {
    yield put(setIsShowLoader(true));
    const result = (yield call([AccessProviderInstance, AccessProviderInstance.update], data)) as RespondClient<unknown>;
    if (result.status !== 200) {
        yield put(onThrowAlert({
            message: result.data,
            lifeTime: 10000
        } as NotificationModel));
    }
    const list = (yield call([AccessProviderInstance, AccessProviderInstance.get], data.schemaId)) as RespondClient<AccessesToModelsDto[]>;
    yield put(setAccessList(list.data));

    yield put(setIsShowLoader(false));

}

export function* watchRemovingAccessModel({ payload: data }: PayloadAction<string>): Generator {
    yield put(setIsShowLoader(true));
    const modelId = (yield select(getOpenedAccessModelId)) as string;

    const result = (yield call([AccessProviderInstance, AccessProviderInstance.delete], data)) as RespondClient<unknown>;
    if (result.status !== 200) {
        yield put(onThrowAlert({
            message: result.data,
            lifeTime: 10000
        } as NotificationModel));
    }
    const list = (yield call([AccessProviderInstance, AccessProviderInstance.get], modelId)) as RespondClient<AccessesToModelsDto[]>;
    yield put(setAccessList(list.data));
    yield put(setIsShowLoader(false));

}

export function* watchSearchingAccessModel({ payload: data }: PayloadAction<{ str: string, id: string }>): Generator {
    yield delay(300);
    const result = (yield call([AccessProviderInstance, AccessProviderInstance.search], data.str, data.id)) as RespondClient<User[]>;
    if (result.status !== 200) {
        yield put(onThrowAlert({
            message: "Faild to fetch users",
            lifeTime: 10000
        } as NotificationModel));
    }
    else {
        yield put(setSearchedUsers(result.data));
    }
}

export function* watchClosingAccessModel(): Generator {
    yield put(setOpenedAccessModelId(""));
    yield put(setIsShowAccessModal(false));
}
